var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-profile-badge text-center",class:{
    'active': (_vm.allowSelection && _vm.badge.isAwarded),
    'awarded': _vm.badge.isAwarded,
    'selected': _vm.badge.isSelected,
  },on:{"click":_vm.selectBadge}},[_c('img',{attrs:{"alt":_vm.badge.name,"src":_vm.badge.imageUrl,"title":_vm.badge.name}}),_vm._v(" "),(_vm.showName)?_c('p',[_vm._v("\n    "+_vm._s(_vm.badge.name)+"\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }